/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontCallButton_seller = {
    readonly serviceId: string | null;
    readonly favoritesByUser?: ReadonlyArray<{
        readonly serviceId: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"CallDealerModal_seller">;
    readonly " $refType": "StorefrontCallButton_seller";
};
export type StorefrontCallButton_seller$data = StorefrontCallButton_seller;
export type StorefrontCallButton_seller$key = {
    readonly " $data"?: StorefrontCallButton_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontCallButton_seller">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "StorefrontCallButton_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "favoritesByUser",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userId"
            }
          ],
          "concreteType": "Favorite",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "CallDealerModal_seller",
      "args": null
    }
  ]
};
})();
(node as any).hash = '1049bab394f92500465654f21567edc6';
export default node;
